import React from "react";
import { useState } from "react";
import { Code, Award, Cpu } from "lucide-react";
import "./Projects.scss";
import greenpaw from "../../assets/images/greenpaw.png";
import elitego from "../../assets/images/elitego.jpg";
import canva from "../../assets/images/canva.png";
import etc from "../../assets/images/etc.png";
import ggStudent from "../../assets/images/certificateStudent.png";
import AIChallenge from "../../assets/images/AIChallenge.png";
import shaing from "../../assets/images/shaing.jpg";
import html from "../../assets/images/html.svg";
import css from "../../assets/images/css.svg";
import firebase from "../../assets/images/firebase.svg";
import java from "../../assets/images/java.svg";
import javascript from "../../assets/images/javascript.svg";
import jetpack from "../../assets/images/jetpack.svg";
import kotlin from "../../assets/images/kotlin.svg";
import mysql from "../../assets/images/mysql.svg";
import nodejs from "../../assets/images/nodejs.svg";
import reactjs from "../../assets/images/reactjs.svg";
import scss from "../../assets/images/scss.svg";
import sql_server from "../../assets/images/sql-server.svg";
import reactNative from "../../assets/images/React-icon.svg.png";

const Projects = () => {
   const [activeTab, setActiveTab] = useState("projects-card");
   const [showCertModal, setShowCertModal] = useState(false);

   return (
      <section id="projects" className="projects-section">
         <div className="projects-container">
            <div className="projects-header">
               <div className="projects-title">Portfolio Showcase</div>
               <div className="projects-subtitle">
                  A collection of my recent projects, showcasing my skills and creativity.
               </div>
            </div>
            {/* Tabs for Projects, Awards, and Skills */}
            <div className="projects-content">
               <div className="projects-middle">
                  <button
                     onClick={() => setActiveTab("projects-card")}
                     className={activeTab === "projects-card" ? "active" : ""}
                  >
                     <Code size={21} />
                     <span>Projects</span>
                  </button>

                  <button
                     onClick={() => setActiveTab("certificates-card")}
                     className={activeTab === "certificates-card" ? "active" : ""}
                  >
                     <Award size={21} />
                     <span>Certificates</span>
                  </button>

                  <button
                     onClick={() => setActiveTab("skills-card")}
                     className={activeTab === "skills-card" ? "active" : ""}
                  >
                     <Cpu size={21} />
                     <span>Skills</span>
                  </button>
               </div>
               {/* Content for each tab */}
               <div className="projects-bottom">
                  {activeTab === "projects-card" && (
                     <div className="project-cards-grid">
                        <div className="project-card">
                           <img src={greenpaw} alt="greenpaw" />
                           <h4>GreenPaw Website</h4>
                           <p>Website to protect the habitats of wildlife</p>
                           <a href="/projects/greenpaw" className="details-btn">
                              Details
                           </a>
                        </div>

                        <div className="project-card">
                           <img src={elitego} alt="Project 2" />
                           <h4>Elite Go App</h4>
                           <p>Technology-based ride-hailing application</p>
                           <a href="/projects/elitego" className="details-btn">
                              Details
                           </a>
                        </div>
                        <div className="project-card">
                           <img src={shaing} alt="Project 3" />
                           <h4>Sharing App</h4>
                           <p>Application to share objects with people around you</p>
                           <a href="/projects/sharing" className="details-btn">
                              Details
                           </a>
                        </div>
                     </div>
                  )}
                  {activeTab === "certificates-card" && (
                     <div className="certificates-grid">
                        {[etc, canva, ggStudent, AIChallenge].map((cert, index) => (
                           <div
                              key={index}
                              className="certificate-img"
                              style={{ backgroundImage: `url(${cert})` }}
                              onClick={() => setShowCertModal(cert)}
                              title="Click to enlarge"
                           ></div>
                        ))}

                        {showCertModal && (
                           <div className="cert-modal" onClick={() => setShowCertModal(false)}>
                              <div
                                 className="certificate-img certificate-img--large"
                                 style={{ backgroundImage: `url(${showCertModal})` }}
                              ></div>
                           </div>
                        )}
                     </div>
                  )}

                  {activeTab === "skills-card" && (
                     <div className="tech-stack-grid">
                        {[
                           { name: "HTML", src: html },
                           { name: "CSS", src: css },
                           { name: "SCSS", src: scss },
                           { name: "JavaScript", src: javascript },
                           { name: "Java", src: java },
                           { name: "ReactJS", src: reactjs },
                           { name: "Node JS", src: nodejs },
                           { name: "Kotlin", src: kotlin },
                           { name: "Jetpack Compose", src: jetpack },
                           { name: "Firebase", src: firebase },
                           { name: "MySQL", src: mysql },
                           { name: "SQL Server", src: sql_server },
                           { name: "React Native", src: reactNative },
                        ].map((tech) => (
                           <div className="tech-card" key={tech.name}>
                              <img src={tech.src} alt={tech.name} />
                              <span>{tech.name}</span>
                           </div>
                        ))}
                     </div>
                  )}
               </div>
            </div>
         </div>
      </section>
   );
};

export default Projects;
